import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Container,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Loader from "widgets/Loader";
import Header from "widgets/Header";

import { fetchModules } from "redux/actions/modulesActions";
import { getRUCEmpresa } from "redux/actions/userActions";
import { MODULE_ROUTES } from "configurations/moduleRoutes";

const useStyles = makeStyles(() => ({
  cardAction: {
    transition: "background-color 0.25s ease, box-shadow 0.25s ease",
    "&:hover": {
      backgroundColor: "#00D923",
      color: "white",
      fontWeight: "bold",
    },
    "&.Mui-disabled": {
      opacity: 0.5,
    },
  },
}));

const ModuleHub = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const tokenUser = useSelector((state) => state.user.tk);
  const history = useHistory();

  const { list, loading, error } = useSelector((state) => state.modules);

  useEffect(() => {
    dispatch(fetchModules(getRUCEmpresa(tokenUser)));
  }, [dispatch, tokenUser]);

  useEffect(() => {
    if (!loading && Array.isArray(list) && list.length === 1) {
      const module = list[0];

      if (module.estado === true) {
        const route = MODULE_ROUTES[module.modulo.idModulo];

        if (route) {
          history.replace(route);
        }
      }
    }
  }, [loading, list, history]);

  const handleOpenModule = (module) => {
    const route = MODULE_ROUTES[module.modulo.idModulo];

    if (!route) {
      console.warn("Ruta no definida para el módulo", module);
      return;
    }

    history.push(route);
  };

  const shouldAutoRedirect =
    !loading &&
    Array.isArray(list) &&
    list.length === 1 &&
    list[0]?.estado === true &&
    Boolean(MODULE_ROUTES?.[list[0]?.modulo?.idModulo]);

  if (loading || shouldAutoRedirect) {
    return (
      <>
        <Header title="Cargando" showMenu={false} />
        <main
          style={{
            minHeight: "calc(100vh - 64px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
          }}
        >
          <Loader />
        </main>
      </>
    );
  }

  return (
    <>
      <Header title="Módulos" showMenu={false} />

      <main
        style={{
          minHeight: "calc(100vh - 64px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
        }}
      >
        <Container maxWidth="lg">
          {error && (
            <Typography color="error" align="center">
              {error}
            </Typography>
          )}

          <Grid container spacing={3} justify="center">
            {Array.isArray(list) && list.map((m) => {
              const isEnabled = m.estado === true;

              return (
                <Grid item xs={12} sm={6} md={4} lg={3} key={m.modulo.idModulo}>
                  <Card>
                    <CardActionArea
                      className={classes.cardAction}
                      disabled={!isEnabled}
                      onClick={() => handleOpenModule(m)}
                    >
                      <CardContent>
                        <Typography variant="h6" align="center">
                          {m.modulo.nombre}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          align="center"
                        >
                          {m.modulo.descripcion || "Abrir módulo"}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </main>
    </>
  );
};

export default ModuleHub;
